import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/data.service";
import { Service } from "../models/service";
import { Environment } from '../models/environment';
import { ODataResponse } from '../models/odata-response';
import { AppConfigService } from 'src/app/core/app-config.service';

@Injectable({
  providedIn: "root",
})
export class EnvironmentDataService extends DataService<Environment> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "Environments", acs);
  }

  environmentCount(
    environmentId: number,
    code: string
  ) {
    let url = `${this.acs.current.configApiUrl}odata/Environments?$filter=Code eq '${code}' and Id ne ${environmentId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<Environment>>(url);
  }  
}
